export type { AlsoAvailableOnSectionFooterProps } from './AlsoAvailableOnSectionFooter';
export { AlsoAvailableOnSectionFooter } from './AlsoAvailableOnSectionFooter';
